import { TabItem, TabBar } from '@/components/TabBar'
import { type OpportunitiesTab } from '@/features/opportunities/OpportunitiesRootViewModel'

export interface OpportunitiesTabBarProps {
  activeTab: OpportunitiesTab
  onChange: (tab: OpportunitiesTab) => unknown
}

export function OpportunitiesTabBar({
  activeTab,
  onChange,
}: OpportunitiesTabBarProps) {
  return (
    <TabBar align="left">
      <TabItem active={activeTab === 'Jobs'} onPress={() => onChange('Jobs')}>
        Available jobs
      </TabItem>
      <TabItem
        active={activeTab === 'Workspaces'}
        onPress={() => onChange('Workspaces')}
      >
        Outsourcing posts
      </TabItem>
    </TabBar>
  )
}
